import { render, staticRenderFns } from "./ClicksMail.vue?vue&type=template&id=52c264ff&scoped=true&"
import script from "./ClicksMail.vue?vue&type=script&lang=js&"
export * from "./ClicksMail.vue?vue&type=script&lang=js&"
import style0 from "./ClicksMail.vue?vue&type=style&index=0&id=52c264ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c264ff",
  null
  
)

export default component.exports